import {EntityService} from '../../../../../service/EntityService';

export class GroupMPermissionService extends EntityService {

  static entity = 'api/app/m-permission';

  static createPermission(data: any): Promise<any>{
    return this.axios.post(`${this.entity}/role-permissions`, data).then(res => res.data);
  }

  static getByName(providerKey: string): Promise<any>{
    return this.axios.get(`${this.entity}?providerName=R&providerKey=${providerKey}`).then(res => res.data);
  }

  static updateByName(providerKey: string, data: any): Promise<any>{
    return this.axios.put(`${this.entity}?providerName=R&providerKey=${providerKey}`, data).then(res => res.data);
  }

  static updateRole(providerKey: string, providerKeyOld: string, data: any): Promise<any>{
    return this.axios.put(`${this.entity}/role?providerName=R&providerKey=${providerKey}&providerKeyOld=${providerKeyOld}`, data).then(res => res.data);
  }
}
